import typia from 'typia'

import { type PreviewCardItem } from '@/components/designPanels/panelMaterials/MaterialContainer'
import {
  type BoundDeviceCategoryType,
  type DesignGroupType,
  type UnboundDeviceCategoryType,
} from '@/graphql/creator-platform/generated'
import {
  type BoundDeviceProductIndicator,
  type UnboundDeviceProductIndicator,
} from '@/store/newProductStore.type'

// 這邊定義整個專案會用到的 LocalStorage kev, value type
export interface LocalStorage {
  readonly recentProducts: {
    readonly recentCategoryType: BoundDeviceCategoryType | UnboundDeviceCategoryType

    readonly boundDevice: Partial<Record<BoundDeviceCategoryType, BoundDeviceProductIndicator>>

    readonly unboundDevice: Partial<
      Record<UnboundDeviceCategoryType, UnboundDeviceProductIndicator>
    >
  }

  readonly boundDesignGroupType: DesignGroupType

  readonly recentBackgrounds: PreviewCardItem[]
  readonly recentCollages: PreviewCardItem[]
}

export function setLocalStorage<Key extends keyof LocalStorage>(
  k: Key,
  v: LocalStorage[Key],
): void {
  localStorage.setItem(k, JSON.stringify(v))
}

export function getRecentBackgrounds(): LocalStorage['recentBackgrounds'] | null {
  const data = getItem('recentBackgrounds')
  return typia.is<LocalStorage['recentBackgrounds']>(data) ? data : null
}

export function getRecentCollages(): LocalStorage['recentCollages'] | null {
  const data = getItem('recentCollages')
  return typia.is<LocalStorage['recentCollages']>(data) ? data : null
}

export function getBoundDesignGroupType(): LocalStorage['boundDesignGroupType'] | null {
  const data = getItem('boundDesignGroupType')
  return typia.is<LocalStorage['boundDesignGroupType']>(data) ? data : null
}

export function getRecentProductsFromLocalStorage(): LocalStorage['recentProducts'] | null {
  const data = getItem('recentProducts')
  return typia.is<LocalStorage['recentProducts']>(data) ? data : null
}

function getItem(key: string): unknown {
  const data = localStorage.getItem(key)
  if (data === null) {
    return null
  }
  return JSON.parse(data) as unknown
}
